import { render, staticRenderFns } from "./pageContent.vue?vue&type=template&id=3a13738c&scoped=true&"
import script from "./pageContent.vue?vue&type=script&lang=ts&"
export * from "./pageContent.vue?vue&type=script&lang=ts&"
import style0 from "./pageContent.vue?vue&type=style&index=0&id=3a13738c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a13738c",
  null
  
)

export default component.exports